import Hammer from 'hammerjs';
import { find, forEach, indexOf, without } from 'lodash';
import mediator, { ACTIONS } from '../mediator';
import svgClasses from '../lib/common/svgClasses';

const CLASS_NAMES = {
  base: 'syos-level',
  active: 'syos-level--active',
  dimmed: 'syos-level--dimmed',
  disabled: 'syos-level--disabled'
};

function handleLevelSelection(levelEls) {
  let ACTIVE_LEVEL = false;

  /**
   * Add base class to level elements
   */
  forEach(levelEls, function(el) {
    svgClasses.addClass(el, CLASS_NAMES.base);
  });

  function resetDisabled(el) {
    svgClasses.removeClass(el, CLASS_NAMES.disabled);
    svgClasses.removeClass(el, CLASS_NAMES.dimmed);
  }

  mediator.subscribe(ACTIONS.LEVEL_SELECTED, function(levelName) {
    if (levelName === null) {
      forEach(levelEls, function(el) {
        svgClasses.removeClass(el, CLASS_NAMES.active);
        resetDisabled(el);
      });

      ACTIVE_LEVEL = false;
    } else {
      let currentLevelEl = find(levelEls, el => el.id === levelName);
      let otherLevels = without(levelEls, currentLevelEl);

      /**
       * Don't do anything if the currently active level is being selected again.
       */
      if (ACTIVE_LEVEL === false || currentLevelEl !== ACTIVE_LEVEL) {
        ACTIVE_LEVEL = currentLevelEl;

        svgClasses.addClass(ACTIVE_LEVEL, CLASS_NAMES.active);
        resetDisabled(currentLevelEl);

        forEach(otherLevels, function(el) {
          svgClasses.removeClass(el, CLASS_NAMES.active);
          svgClasses.addClass(el, CLASS_NAMES.dimmed);

          /**
           * Only disable pointer events on levels
           * above the currently selected one.
           */
          let levelIdx = indexOf(levelEls, el);
          let currIdx = indexOf(levelEls, currentLevelEl);
          if (levelIdx > currIdx) {
            svgClasses.addClass(el, CLASS_NAMES.disabled);
          }
        });
      }
    }
  });
}

function handleClicks(seatMapEl, levelEls) {
  /**
   * Handle clicking on a level
   */
  forEach(levelEls, function(el) {
    let trigger = new Hammer(el);
    trigger.on('tap', function() {
      mediator.publish(ACTIONS.LEVEL_PRESELECTED, el.id);
    });
  });
}

export function animateMap(seatMapEl, levelEls) {
  if (levelEls.length > 1) {
    handleLevelSelection(levelEls);
    handleClicks(seatMapEl, levelEls);
  } else {
    forEach(levelEls, function(el) {
      svgClasses.addClass(el, CLASS_NAMES.active);
    });
  }
}

export function setLevel(levelId) {
  mediator.publish(ACTIONS.LEVEL_SELECTED, levelId);
}



// WEBPACK FOOTER //
// ./src/javascripts/behaviours/animateMap.js